import React from 'react'
import { FaHeart } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { BiSolidZap } from "react-icons/bi";
import { useTranslation } from 'react-i18next';
import { IoSparklesSharp } from "react-icons/io5";
import IntroductionImg from "../assets/OwnerImage.png"

const IntroductionSection = () => {
    const { t } = useTranslation();

  return (
    <div className='container relative my-20 mx-auto flex md:flex-row flex-col gap-10 justify-around items-center p-6'>
    <div  className='md:w-2/4'>
      <h1 className="md:text-4xl leading-normal text-2xl font-semiobld font-Merriweather max-w-sm md:text-start text-center">{t('aboutSection.heading')}</h1>
      <p className="my-5 text-gray-600 text-xs md:text-sm font-semibold md:text-start text-center">{t('aboutSection.introParagraph')}</p>
      <p className="flex items-center gap-2 mt-5 font-medium"><FaHeart className="text-2xl text-[rgb(161,121,61)]" /> {t('aboutSection.benefit1.text')}</p>
      <p className="flex items-center gap-2 mt-5 font-medium"><BiSolidZap className="text-3xl text-[rgb(161,121,61)]" /> {t('aboutSection.benefit2.text')}</p>
      <p className="my-5 text-xs md:text-sm text-gray-600 font-semibold md:text-start text-center">{t('aboutSection.servicesParagraph')}</p>
      <button className="p-2.5 px-5 bg-[rgb(161,121,61)] text-white rounded-md flex md:mx-0 mx-auto font-poppins font-medium">
        <Link to='/services'>
        {t('aboutSection.buttonText')}
        </Link>
      </button>
        </div>
        <div className='md:w-2/5' data-aos='fade-right'>
            <img src={IntroductionImg} alt="Introduction Image" className='rounded-md' />
        </div>
    </div>
  )
}

export default IntroductionSection